import { combineReducers } from 'redux';
import formReducer from './form';
import dirty from './dirty';
import requirementsReducer from './requirements';

export default combineReducers({
  form: formReducer,
  dirty,
  requirements: requirementsReducer,
});

export const isFetching = state => state.form.isFetching;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/organize/reducers/index.js